import React from 'react'
import { Box } from '@mui/material'
import { advancedColors } from '../../theme'

const UnreadCount = ({ count }: { count: number }) =>
  count > 0 ? (
    <Box
      component="span"
      role="img"
      aria-label={`${count} unread`}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        minWidth: 18,
        height: 18,
        px: 0.5,
        borderRadius: 9,
        backgroundColor: advancedColors.error,
        color: advancedColors.surface,
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1,
      }}
    >
      {count > 99 ? '99+' : count}
    </Box>
  ) : null

export default UnreadCount
